import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { DevelopmentService } from '../../development';
import { AlertService, ConstantService } from '../../../_services';
import { ApiResponse } from '../../../_models';
import { Feature } from '@app/_components/property/feature';

@Component({
    selector: 'app-development',
    templateUrl: './development.component.html',
    styleUrls: ['./development.component.css'],
    standalone: false
})
export class DevelopmentComponent implements OnInit {
    locations: any[];

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private developmentService: DevelopmentService,
		private alertService: AlertService,
		private location: Location,
		private constantService: ConstantService,
		private formBuilder: UntypedFormBuilder) { 
			this.locations = constantService.locations;
		}

	// structure
	subscription: Subscription;
	routerLocation = this.location;
	


	// data
	developmentApiResponse: ApiResponse;
	developmentTemplateResApi: ApiResponse;
	development;
	developmentId: number;
	reservationId: number;
	featuresList: Feature[] = [];


	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAction: String;
	formLabels = [];
	formReadOnly = false;

	adrTypes = [
		{ value: 'SP', name: 'Subject Development' }
	];

	sizeUnitOfMeasurements = [
		{ value: 'SQUARE_FEET', name: 'Square Feet' }
	];

	keyServiceTypes = [
		{ value: 'KK', name: 'Kaba' },
		{ value: 'KM', name: 'Meet and Greet' },
		{ value: 'KE', name: 'Front Desk' }
	];

	listingStatuses = [
		{ value: 0, name: 'Active' },
		{ value: 2, name: 'Suspended' },
		{ value: 1, name: 'Archived' }
	];

	developmentTypes = [
		{ value: '14', name: 'Single Family Home' },
		{ value: '01', name: 'Condominium' },
		{ value: '16', name: 'Townhome' }

	];

	developmentSubTypes = [
		{ value: '', name: 'Standard' }
	];

	hotelRoomTypes = [
		{ value: 0, name: 'DO NOT SELL HOTEL' },
		{ value: 1, name: 'Studio Ocean View' },
		{ value: 2, name: 'Studio Partial Ocean View' },
		{ value: 3, name: 'Studio Resort View' },
		{ value: 4, name: 'Studio Construction View' },
		{ value: 5, name: '1 Bed Ocean View' },
		{ value: 6, name: '1 Bed Partial Ocean View' },
		{ value: 7, name: '1 Bed Resort View' },
		{ value: 8, name: '1 Bed Construction View' },
		{ value: 9, name: '2 Bed Ocean View' },
		{ value: 10, name: '2 Bed Partial Ocean View' },
		{ value: 11, name: '2 Bed Resort View' },
		{ value: 12, name: '2 Bed Construction View' },
		{ value: 13, name: '3 Bed Ocean View' },
		{ value: 14, name: '3 Bed Partial Ocean View' },
		{ value: 15, name: '3 Bed Resort View' },
		{ value: 16, name: '3 Bed Construction View' },
		{ value: 17, name: '3 Bed Presidential Suite' },
		{ value: 18, name: '4 Bed Ocean View' },
		{ value: 19, name: '4 Bed Partial Ocean View' },
		{ value: 20, name: '4 Bed Resort View' },
		{ value: 21, name: '4 Bed Construction View' },
		{ value: 22, name: '4 Bed Presidential Suite' },
		{ value: 23, name: '5 Bed Ocean View' },
		{ value: 24, name: '5 Bed Partial Ocean View' },
		{ value: 25, name: '5 Bed Resort View' },
		{ value: 26, name: '5 Bed Construction View' },
		{ value: 27, name: '5 Bed Presidential Suite' },
		{ value: 28, name: '6 Bed Ocean View' },
		{ value: 29, name: '6 Bed Partial Ocean View' },
		{ value: 30, name: '6 Bed Resort View' },
		{ value: 31, name: '6 Bed Construction View' },
		{ value: 32, name: '6 Bed Presidential Suite' },
	];


	locales = [
		{ value: 'en', name: 'English' }
	];

	booleans = [
		{ value: true, name: 'Yes' },
		{ value: false, name: 'No' }
	];

	countries: any[] =
		[
			{ name: '', value: '' },
			{ name: 'Canada', value: 'CA' },
			{ name: 'United States', value: 'US' },
		];

	orders = [];

	validationMessages = {
		'developmentId': [],
		'createDate': [],
		'lastUpdate': [],
		'locale': [],
		'listingStatus': [],
		'propertyCode': [
			{ type: 'required', message: 'Required' },
			{ type: 'maxlength', message: '15 characters maximum' }],
		'developmentType': [],
		'developmentSubType': [],
		'hotelRoomType': [],
		'bedroomNum': [],
		'bathroomNum': [],
		'sleepsMax': [],
		'sleepsMaxInBeds': [],
		'floorsTotal': [],
		'buildingsTotal': [],
		'yearBuilt': [],
		'unitsTotal': [],
		'sizeLot': [],
		'sizeExterior': [],
		'sizeUnitOfMeasurement': [],

		// marketing
		'mgmtCommission': [],
		'minNightlyRate': [],
		'minLengthOfStay': [],
		'cleaningFeeDeparture': [],
		'cleaningFeeInterim': [],
		'showPublicCalendar': [],
		'showBookOnline': [],
		'keyServiceType': [],


		// ids
		'taxId': [],
		'permitId': [],
		'vrboId': [],
		'ruBuildingId': [],
		'locationId': [],


		// address
		'adrType': [],
		'adrDevelopmentName': [],
		'adrStreetNumber': [],
		'adrStreetName': [],
		'adrUnit': [],
		'adr2': [],
		'adrBuildingName': [],
		'adrComplexName': [],
		'adrDistrictName': [],
		'adrCity': [],
		'adrCounty': [],
		'adrMetro': [],
		'adrCountry': [],
		'adrRegion': [],
		'adrState': [],
		'adrPostalCode': [],
		'adrIsland': [],
		'adrCrossStreet': [],
		'adrLongitude': [],
		'adrLatitude': [],

		'propDescShort': [],

		'propDesc': [],
		'loacationDesc': [],
		'featureDesc': [],
		'accessDesc': [],
		'disabledDesc': [],
		'petsDesc': [],
		'parkingDesc': [],
		'parkingFeeDesc': [],
		'arrivalInstructionsDesc': [],
		'maintenanceIssuesDesc': [],
		'contractTerms': [],
		'termsDesc': [],


		'parkingFee': [],
		'loacationType': [],
		'directionsToProperty': [],
		'codeFrontDoor': [],
		'codeGarage': [],
		'codeGate': [],
		'codeHoaGate': [],
		'codePool': [],
		'codeRecreation': [],
		'elevator': [],
		'disabled': [],
		'pets': [],
		'newReservationAlertEmail': [],
		propDescShortKeyWords: [],
		newOwnerGuestReservationAlertEmail: [],
			newOwnerReservationAlertEmail: [],
		propTagline: [],
		showDevelopmentOnline: []



	};

	getOrders() {
		return [
			{ id: '1', name: 'order 1' },
			{ id: '2', name: 'order 2' },
			{ id: '3', name: 'order 3' },
			{ id: '4', name: 'order 4' }
		];
	}




	ngOnInit() {

		// formAction — development-view and development-edit both open in edit mode
		this.formAction = this.router.url.startsWith('/development-add') ? 'add' : this.router.url.startsWith('/development-edit') ? 'edit' : this.router.url.startsWith('/development-view') ? 'edit' : '/';

		/**
				 *
				 *
				 *
				 * DATA
				 *
				*/
		this.featuresList = this.activatedRoute.snapshot.data.availableDevelopmentFeaturesResApi.data.propertyFeatures;

		/**
				 *
				 *
				 *
				 * ACTIONS (ADD / EDIT / DETAIL)
				 *
				 */
		try {
			// add
			if (this.formAction === 'add') {
				this.formLabels['title'] = 'Add New Development Manager';
				this.formReadOnly = false;
				this.formBuild();
				this.form1.patchValue({
					showDevelopmentOnline : true
				});
			}

			// edit
			else if (this.formAction === 'edit') {

				this.subscription = this.activatedRoute.params.subscribe(params => {
					this.developmentId = params.developmentId; // (+) converts string 'id' to a number
					this.reservationId = params.reservationId; // (+) converts string 'id' to a number
				});
				this.formLabels['title'] = 'Edit';
				this.formReadOnly = false;
				this.formBuild();

				// get data
				this.development = this.findById(+this.developmentId);
				if (this.development?.showDevelopmentOnline == undefined || this.development?.showDevelopmentOnline == null) {
					this.development.showDevelopmentOnline = false;
				}
				// patch in data
				this.form1.patchValue(this.development);
			}

			// view
			else if (this.formAction === 'view') {
				this.subscription = this.activatedRoute.params.subscribe(params => {
					this.developmentId = params.developmentId; // (+) converts string 'id' to a number
				});
				this.formLabels['title'] = '';
				this.formReadOnly = true;
				this.formBuild();

				// get data
				this.development = this.findById(+this.developmentId);
				if (this.development?.showDevelopmentOnline == undefined || this.development?.showDevelopmentOnline == null) {
					this.development.showDevelopmentOnline = false;
				}

				// patch in data
				this.form1.patchValue(this.development);
			}
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}


	formBuild() {
		/**
				   *
				   *
				   *
				   * FORM
				   *
				   */

		this.form1 = this.formBuilder.group({
			developmentId: [this.developmentId],
			createDate: [],
			lastUpdate: [],
			locale: [],
			listingStatus: [],
			propertyCode: [],
			developmentType: [],
			developmentSubType: [],
			hotelRoomType: [],
			bedroomNum: [],
			bathroomNum: [],
			sleepsMax: [],
			sleepsMaxInBeds: [],
			floorsTotal: [],
			buildingsTotal: [],
			yearBuilt: [],
			unitsTotal: [],
			sizeLot: [],
			sizeExterior: [],
			sizeUnitOfMeasurement: [],
			propDescShortKeyWords: [],

			// marketing
			mgmtCommission: [],
			minNightlyRate: [],
			minLengthOfStay: [],
			cleaningFeeDeparture: [],
			cleaningFeeInterim: [],
			showPublicCalendar: [],
			showBookOnline: [],
			keyServiceType: [],


			// ids
			taxId: [],
			permitId: [],
			vrboId: [],
			ruBuildingId: [],
			locationId: [],


			// address
			adrType: [],
			adrDevelopmentName: [],
			adrStreetNumber: [],
			adrStreetName: [],
			adrUnit: [],
			adr2: [],
			adrBuildingName: [],
			adrComplexName: [],
			adrDistrictName: [],
			adrCity: [],
			adrCounty: [],
			adrMetro: [],
			adrCountry: [],
			adrRegion: [],
			adrState: [],
			adrPostalCode: [],
			adrIsland: [],
			adrCrossStreet: [],
			adrLongitude: [],
			adrLatitude: [],

			// descriptions
			propDescShort: [],
			propDesc: [],
			loacationDesc: [],
			featureDesc: [],
			accessDesc: [],
			disabledDesc: [],
			petsDesc: [],
			parkingDesc: [],
			parkingFeeDesc: [],
			arrivalInstructionsDesc: [],
			maintenanceIssuesDesc: [],
			contractTerms: [],
			termsDesc: [],

			// misc
			parkingFee: [],
			loacationType: [],
			directionsToProperty: [],
			codeFrontDoor: [],
			codeGarage: [],
			codeGate: [],
			codeHoaGate: [],
			codePool: [],
			codeRecreation: [],
			elevator: [],
			disabled: [],
			pets: [],
			newReservationAlertEmail: [],
			newOwnerGuestReservationAlertEmail: [],
			newOwnerReservationAlertEmail: [],
			propTagline: [],
			showDevelopmentOnline: []


		});
	}


	formAdd() {
		try {
			// stop here if form is invalid
			if (this.form1.invalid) {
				return;
			}

			this.formLoading = true;
			this.form1.value.showDevelopmentOnline = true;
			this.developmentService.add(this.form1.value)
				.subscribe(
					res => {
						console.log('development-add SUCCESS: ' + JSON.stringify(res));
						this.developmentId = res.data.development.developmentId;
						this.router.navigate(['/development-view', this.developmentId]);
					},
					err => {
						console.log('development-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {

		try {
			// stop here if form is invalid
			if (this.form1.invalid) {
				console.log(this.findInvalidControls());
				return;
			}
			console.log('development-before-updates: ' + JSON.stringify(this.form1.value));
			if(this.form1.value.propDescShortKeyWords != undefined && this.form1.value.propDescShortKeyWords != null && this.form1.value.propDescShortKeyWords != ""){
				this.form1.value.propDescShortKeyWords = this.sanitizeTextPreserveParagraphs(this.form1.value.propDescShortKeyWords);
			}
			if(this.form1.value.termsDesc != undefined && this.form1.value.termsDesc != null && this.form1.value.termsDesc != ""){
				this.form1.value.termsDesc = this.sanitizeTextPreserveParagraphs(this.form1.value.termsDesc);
			}
			if(this.form1.value.contractTerms != undefined && this.form1.value.contractTerms != null && this.form1.value.contractTerms != ""){
				this.form1.value.contractTerms = this.sanitizeTextPreserveParagraphs(this.form1.value.contractTerms);
			}
			if(this.form1.value.maintenanceIssuesDesc != undefined && this.form1.value.maintenanceIssuesDesc != null && this.form1.value.maintenanceIssuesDesc != ""){
				this.form1.value.maintenanceIssuesDesc = this.sanitizeTextPreserveParagraphs(this.form1.value.maintenanceIssuesDesc);
			}
			if(this.form1.value.arrivalInstructionsDesc != undefined && this.form1.value.arrivalInstructionsDesc != null && this.form1.value.arrivalInstructionsDesc != ""){
				this.form1.value.arrivalInstructionsDesc = this.sanitizeTextPreserveParagraphs(this.form1.value.arrivalInstructionsDesc);
			}
			if(this.form1.value.parkingFeeDesc != undefined && this.form1.value.parkingFeeDesc != null && this.form1.value.parkingFeeDesc != ""){
				this.form1.value.parkingFeeDesc = this.sanitizeTextPreserveParagraphs(this.form1.value.parkingFeeDesc);
			}
			if(this.form1.value.parkingDesc != undefined && this.form1.value.parkingDesc != null && this.form1.value.parkingDesc != ""){
				this.form1.value.parkingDesc = this.sanitizeTextPreserveParagraphs(this.form1.value.parkingDesc);
			}
			if(this.form1.value.petsDesc != undefined && this.form1.value.petsDesc != null && this.form1.value.petsDesc != ""){
				this.form1.value.petsDesc = this.sanitizeTextPreserveParagraphs(this.form1.value.petsDesc);
			}
			if(this.form1.value.disabledDesc != undefined && this.form1.value.disabledDesc != null && this.form1.value.disabledDesc != ""){
				this.form1.value.disabledDesc = this.sanitizeTextPreserveParagraphs(this.form1.value.disabledDesc);
			}
			if(this.form1.value.accessDesc != undefined && this.form1.value.accessDesc != null && this.form1.value.accessDesc != ""){
				this.form1.value.accessDesc = this.sanitizeTextPreserveParagraphs(this.form1.value.accessDesc);
			}
			if(this.form1.value.featureDesc != undefined && this.form1.value.featureDesc != null && this.form1.value.featureDesc != ""){
				this.form1.value.featureDesc = this.sanitizeTextPreserveParagraphs(this.form1.value.featureDesc);
			}
			if(this.form1.value.loacationDesc != undefined && this.form1.value.loacationDesc != null && this.form1.value.loacationDesc != ""){
				this.form1.value.loacationDesc = this.sanitizeTextPreserveParagraphs(this.form1.value.loacationDesc);
			}
			if(this.form1.value.propDesc != undefined && this.form1.value.propDesc != null && this.form1.value.propDesc != ""){
				this.form1.value.propDesc = this.sanitizeTextPreserveParagraphs(this.form1.value.propDesc);
			}
			if(this.form1.value.propDescShort != undefined && this.form1.value.propDescShort != null && this.form1.value.propDescShort != ""){
				this.form1.value.propDescShort = this.sanitizeTextPreserveParagraphs(this.form1.value.propDescShort);
			}
			this.formLoading = true;

			this.developmentService.update(this.form1.value)
				.subscribe(
					res => {
						console.log('development-update SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
					},
					err => {
						console.log('development-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	findById(id: number) {
		try {
			this.formLoading = true;
			this.developmentService.findById(id)
				.subscribe(
					res => {
						console.log('development-find SUCCESS: ' + JSON.stringify(res));
						this.developmentApiResponse = res;
						this.development = res.data.development;
						if(this.development?.showDevelopmentOnline == undefined || this.development?.showDevelopmentOnline == null){
							this.development.showDevelopmentOnline = false;
						}
						this.form1.patchValue(this.development);
					},
					err => {
						console.log('development-find FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	public findInvalidControls() {
		const invalid = [];
		const controls = this.form1.controls;
		for (const name in controls) {
			if (controls[name].invalid) {
				invalid.push(name);
			}
		}
		return invalid;
	}

	// This method for remove Unicode from paragraph
	sanitizeTextPreserveParagraphs(input: string): string {
		return input
		  .normalize('NFC') // Normalize Unicode characters
		  .replace(/[\u00A0\u200B-\u200F\u2028\u2029\uFEFF]/g, '') // Remove unwanted Unicode characters
		  .replace(/[^\S\r\n]+/g, ' ') // Convert irregular spaces (excluding new lines) to single spaces
		  .trim(); // Remove leading and trailing spaces
	  }
}
